import { FC } from 'react';
import {
  CheckCircleOutlined,
  CloseOutlined,
  EditOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';

type Props = {
  status: string;

  style?: React.CSSProperties;
  label?: string;
};

const statuses = {
  editable: {
    label: 'Draft',
    color: 'default',
    icon: <EditOutlined />,
  },
  error: {
    label: 'Error',
    color: 'red',
    icon: <CloseOutlined />,
  },
  generating: {
    label: 'Generating',
    color: 'blue',
    icon: <LoadingOutlined />,
  },
  published: {
    label: 'Published',
    color: 'green',
    icon: <CheckCircleOutlined />,
  },
  active: {
    label: 'Active',
    color: 'blue',
    icon: null,
  },
  completed: {
    label: 'Completed',
    color: 'green',
    icon: null,
  },
};

export const StatusField: FC<Props> = ({ status, style, label }) => {
  const statusData = statuses[status as keyof typeof statuses];

  if (!statusData) {
    return null;
  }

  const displayLabel = label || statusData?.label;

  return (
    <Tag
      icon={statusData?.icon}
      color={statusData?.color}
      style={{
        opacity: 0.8,
        marginRight: 0,
        display: 'flex',
        alignItems: 'center',
        ...style,
      }}
    >
      {displayLabel}
    </Tag>
  );
};
